<div *ngIf="vo$ | async; let vo">
	<app-page>
		<app-page-header class="app-project-list__header">
			<div *ngIf="vo.viewMode === 'CARD'" class="app-project-list__title">
				<span i18n="@@project.list.title">Projects</span>
				<span>&nbsp;({{ vo.items.elements.size }})</span>
			</div>
			<dc-alert
				*ngIf="vo.hasOrphanProjects"
				class="app-project-list__warning"
				(click)="navigateToOrphanProjects()"
				[type]="'warning'"
				message="message"
				i18n-message="@@project.list.orphan-projects-detected"></dc-alert>
		</app-page-header>
		<app-page-actions class="app-project-list__page-actions">
			<mat-form-field
				*ngIf="vo.viewMode === 'CARD'"
				class="app-project-list__search-input">
				<mat-label i18n="@@project.card.search">search</mat-label>
				<input
					id="{{ cmpId }}-search-input"
					type="text"
					[(ngModel)]="vo.searchTerm"
					(ngModelChange)="searchProjectCards($event)"
					matInput />
			</mat-form-field>
			<app-toggle-buttons [actions]="viewModes"></app-toggle-buttons>
			<button
				*ngIf="vo.isAdmin"
				matTooltip="new"
				id="{{ cmpId }}-new-btn"
				i18n-matTooltip="@@general.action.new"
				class="app-project-list__create-btn"
				mat-icon-button
				color="primary"
				[matMenuTriggerFor]="projectMenu">
				<mat-icon [svgIcon]="DcIcons.AddElement"></mat-icon>
			</button>
			<mat-menu #projectMenu="matMenu">
				<ng-template matMenuContent let-data>
					<button
						*ngFor="let a of menuCreateActions"
						id="{{ cmpId }}-{{ a.actionName }}-btn"
						(click)="a.action(data)"
						mat-menu-item>
						<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
						<span>{{ a.description }}</span>
					</button>
				</ng-template>
			</mat-menu>
		</app-page-actions>
		<app-page-content class="app-page-content">
			<div *ngIf="vo.viewMode === 'CARD'" class="project-cards">
				<ng-container *ngTemplateOutlet="projectCards"></ng-container>
			</div>
			<div *ngIf="vo.viewMode === 'LIST'">
				<app-panel
					headerHeight="3rem"
					isAlwaysOpen="true"
					hasSearchableGrid="true"
					hasRefresh="true"
					maxActionsCount="6"
					[itemsCount]="vo.items.elements.size"
					(refresh)="refresh()"
					(search)="search($event)">
					<span panel-title class="app-project-list__panel-title">
						<mat-icon [svgIcon]="DcIcons.Project"></mat-icon>
						<span i18n="@@project.list.title">Projects</span>
					</span>

					<dx-data-grid
						keyExpr="id"
						[elementAttr]="{ id: 'project-list', class: 'app-project-list' }"
						[dataSource]="vo.items.elements | toArray"
						[hoverStateEnabled]="true"
						[showColumnHeaders]="true"
						[allowColumnResizing]="true"
						[columnAutoWidth]="false"
						[showRowLines]="false"
						[showColumnLines]="false"
						[rowAlternationEnabled]="false"
						[showBorders]="false"
						[width]="'100%'"
						(onCellHoverChanged)="onCellHover($event)"
						(onRowClick)="rowClick($event)"
						(onContentReady)="onGridContentReady()">
						<dxo-header-filter [visible]="true"></dxo-header-filter>

						<dxo-load-panel
							shadingColor="rgba(0,0,0,0)"
							[indicatorSrc]="DcLoaders.LoaderInfinite"
							[height]="100"
							[width]="100"
							[enabled]="true"
							[showIndicator]="true"
							[showPane]="true"
							[shading]="true"></dxo-load-panel>

						<!-- Fixable in position columns	-->
						<dxo-column-fixing [enabled]="true"></dxo-column-fixing>

						<ng-container
							*ngFor="let col of vo.items.availableColumns | toArray">
							<dxi-column
								*ngIf="col.field === 'description'"
								[dataField]="col.field"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[visible]="col.visible"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="true"
								[format]="col.format"
								[alignment]="'left'"
								[visibleIndex]="col.visibleIndex"
								[allowHeaderFiltering]="col.hasHeaderFilter"></dxi-column>
							<dxi-column
								*ngIf="col.field === 'label'"
								[dataField]="col.field"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[visible]="col.visible"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="true"
								[format]="col.format"
								[alignment]="'left'"
								[visibleIndex]="col.visibleIndex"
								[allowHeaderFiltering]="col.hasHeaderFilter"
								[minWidth]="100"
								[width]="'20%'"></dxi-column>
							<dxi-column
								*ngIf="col.field === 'tags'"
								[dataField]="col.field"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[visible]="col.visible"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="true"
								[format]="col.format"
								[alignment]="'left'"
								[visibleIndex]="col.visibleIndex"
								[allowHeaderFiltering]="col.hasHeaderFilter"
								[dataType]="col.type"
								[filterOperations]="[DxOperations.Contains, DxOperations.In]"
								[calculateFilterExpression]="
									calculateTagsHeaderFilterExpression
								"
								[filterValue]="col.filterValue"
								[filterValues]="col.filterValues"
								[sortIndex]="col.sortIndex"
								[sortOrder]="col.sortOrder"
								[width]="col.width ?? 300"
								cellTemplate="tagsTemplate">
								<dxo-header-filter
									[dataSource]="tagsHeaderFilter"></dxo-header-filter>
							</dxi-column>
							<dxi-column
								*ngIf="col.field === 'accessDate'"
								[dataField]="col.field"
								[dataType]="col.type"
								[format]="col.format"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="true"
								[alignment]="'left'"
								[visibleIndex]="col.visibleIndex"
								[allowHeaderFiltering]="col.hasHeaderFilter"
								[visible]="col.visible"
								[filterValue]="col.filterValue"
								[filterValues]="col.filterValues"
								[sortIndex]="col.sortIndex"
								[sortOrder]="col.sortOrder"
								[width]="col.width ?? 200"
								cellTemplate="accessTemplate"></dxi-column>
							<dxi-column
								*ngIf="col.field === 'accessedByAvatar'"
								[dataField]="col.field"
								[caption]="col.alias"
								[groupIndex]="col.groupIdx"
								[fixed]="false"
								[allowResizing]="true"
								[allowHiding]="true"
								[allowGrouping]="true"
								[allowSearch]="col.isSearchable"
								[allowFiltering]="col.isFilterable"
								[allowSorting]="false"
								[alignment]="'left'"
								[dataType]="col.type"
								[format]="col.format"
								[visibleIndex]="col.visibleIndex"
								[allowHeaderFiltering]="col.hasHeaderFilter"
								[filterOperations]="[
									DxOperations.Contains,
									DxOperations.NotContains,
									DxOperations.StartsWith,
									DxOperations.In
								]"
								[calculateFilterExpression]="
									calculateAccessByHeaderFilterExpression
								"
								[filterValue]="col.filterValue"
								[filterValues]="col.filterValues"
								[sortIndex]="col.sortIndex"
								[sortOrder]="col.sortOrder"
								[width]="col.width"
								cellTemplate="accessedByAvatarTemplate">
								<dxo-header-filter
									[dataSource]="accessedByHeaderFilter"></dxo-header-filter>
							</dxi-column>
						</ng-container>

						<dxi-column
							[fixed]="false"
							[allowResizing]="false"
							[allowHiding]="false"
							[allowGrouping]="false"
							[allowSearch]="false"
							[allowSorting]="false"
							[alignment]="'left'"
							[visibleIndex]="vo.items.availableColumns.size + 1"
							[showInColumnChooser]="false"
							[width]="'10rem'"
							cellTemplate="actionsTemplate"></dxi-column>

						<div *dxTemplate="let cell of 'tagsTemplate'">
							<app-tag-configurator
								*ngIf="cell.data['tags'].length !== 0"
								displayMode="tags"
								configMode="View"
								[configuredTags]="cell.data['tags']"></app-tag-configurator>
						</div>

						<div *dxTemplate="let cell of 'accessTemplate'">
							<span>
								{{ cell.data['accessDate'] | date: 'yyyy-MM-dd HH:mm' }}
							</span>
						</div>

						<div
							class="actions-column-template"
							*dxTemplate="let cell of 'actionsTemplate'">
							<app-overlay-badge
								*ngIf="cell.data['isAdmin']"
								id="{{ cmpId }}-{{ cell.rowIndex }}-show-info-btn"
								[active]="true"
								[icon]="ComponentIcons.Info"
								[isOpen]="vo.openedOverlays.detailsPanelId === cell.data['id']"
								(overlayDismiss)="closeOverlay()"
								(click)="openInfoOverlay($event, cell.data['id'])">
								<app-popover
									id="project-list-details-popover"
									class="info-popover"
									overlayContent
									[icon]="{ iconName: ComponentIcons.Info }"
									(adbPopoverClose)="closeOverlay()">
									<ng-container
										[ngTemplateOutlet]="projectInfo"
										[ngTemplateOutletContext]="{
											$implicit: cell.data
										}"></ng-container>
								</app-popover>
							</app-overlay-badge>
							<div>
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-set-default-btn"
									mat-icon-button
									class="actions-column-template__btn"
									(click)="setDefault($event, cell.data)">
									<mat-icon
										[svgIcon]="
											cell.data['isDefault'] ? DcIcons.KeepFilled : DcIcons.Keep
										"></mat-icon>
								</button>
								<button
									id="{{ cmpId }}-{{ cell.rowIndex }}-set-favorite-btn"
									mat-icon-button
									class="actions-column-template__btn"
									(click)="setFavorite($event, cell.data)">
									<mat-icon
										[svgIcon]="
											cell.data.isFavorite
												? DcIcons.FavoriteFilled
												: DcIcons.Favorite
										"></mat-icon>
								</button>
								<button
									*ngIf="cell.data['isAdmin']"
									id="{{ cmpId }}-{{ cell.rowIndex }}-actions-menu-btn"
									mat-icon-button
									class="actions-column-template__btn"
									(click)="rowMenuOpen($event, cell.rowIndex)"
									[matMenuTriggerFor]="menuActions"
									[matMenuTriggerData]="{ $implicit: cell.data }">
									<mat-icon
										[svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
								</button>
								<mat-menu #menuActions="matMenu">
									<ng-template matMenuContent let-data>
										<button
											*ngFor="let a of menuRowActions"
											id="{{ cmpId }}-{{ cell.rowIndex }}-{{
												a.actionName
											}}-btn"
											(click)="a.action(data)"
											mat-menu-item>
											<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
											<span>{{ a.description }}</span>
										</button>
									</ng-template>
								</mat-menu>
							</div>
						</div>
						<div *dxTemplate="let cell of 'accessedByAvatarTemplate'">
							<app-avatar
								*ngIf="cell.data['accessedByAvatar']"
								[avatar]="cell.data['accessedByAvatar']"
								[withTooltip]="true"></app-avatar>
						</div>

						<dxo-group-panel [visible]="true"></dxo-group-panel>

						<!-- Filterable columns	-->
						<dxo-filter-row [visible]="true"></dxo-filter-row>

						<!-- Sorting	-->
						<dxo-sorting mode="multiple"></dxo-sorting>

						<!-- Pagination -->
						<dxo-paging [pageSize]="10"></dxo-paging>

						<dxo-column-chooser
							[allowSearch]="true"
							[enabled]="false"
							[mode]="'select'">
							<dxo-selection
								[allowSelectAll]="true"
								[recursive]="false"></dxo-selection>
						</dxo-column-chooser>

						<dxo-filter-panel [visible]="true"></dxo-filter-panel>

						<!-- State persistence	-->
						<dxo-state-storing
							type="custom"
							[enabled]="true"
							[savingTimeout]="160"
							[customLoad]="loadState"
							[customSave]="saveState"></dxo-state-storing>
					</dx-data-grid>
				</app-panel>
			</div>
		</app-page-content>
	</app-page>

	<ng-template #projectCards>
		<mat-card
			*ngFor="let project of vo.items.elements | toArray; index as index"
			(click)="navigateToProject(project)"
			class="project-card"
			[ngClass]="{
				'project-card--not-allowed': project.isExpired || !project.isActive
			}">
			<mat-card-title class="project-card__header">
				<div class="project-card__icon">
					<img [src]="project.imageUrl" [alt]="project.imageUrl" />
				</div>
				<div class="project-card__subheader">
					<div class="project-card__title">
						<span
							class="project-title"
							[matTooltipDisabled]="project.label.length < labelMaxCharCount"
							[matTooltip]="project.label">
							{{
								project.label
									| truncate: labelMaxCharCount:labelMaxLinesCount:'end'
							}}
						</span>
						<div *ngIf="project.isAdmin" class="project-card__header-actions">
							<button
								id="{{ cmpId }}-{{ index }}-edit-btn"
								class="project-card__actions-btn"
								mat-icon-button
								(click)="navigateToProjectEdit($event, project.id)">
								<mat-icon [svgIcon]="DcIcons.Settings"></mat-icon>
							</button>
							<button
								*ngIf="project.isAdmin"
								id="{{ cmpId }}-{{ index }}-card-menu-btn"
								mat-icon-button
								class="project-card__actions-btn"
								(click)="cardMenuOpen($event)"
								[matMenuTriggerFor]="cardMenu"
								[matMenuTriggerData]="{ $implicit: project }">
								<mat-icon [svgIcon]="DcIcons.MenuMoreOptionsHandle"></mat-icon>
							</button>
							<mat-menu #cardMenu="matMenu">
								<ng-template matMenuContent let-project>
									<button
										*ngFor="let a of menuCardActions"
										id="{{ cmpId }}-{{ project.id }}-{{ a.actionName }}-btn"
										(click)="a.action(project)"
										mat-menu-item>
										<mat-icon *ngIf="a.icon" [svgIcon]="a.icon"></mat-icon>
										<span>{{ a.description }}</span>
									</button>
								</ng-template>
							</mat-menu>
						</div>
					</div>
					<mat-divider></mat-divider>
				</div>
			</mat-card-title>
			<mat-card-content>
				<div
					*ngIf="!project.isExpired && project.isActive"
					class="project-card__content">
					<div
						[matTooltip]="project.description"
						[matTooltipDisabled]="
							project.description.length < descriptionMaxCharCount
						">
						{{
							project.description
								| truncate
									: descriptionMaxCharCount
									: descriptionMaxLinesCount
									: 'end'
						}}
					</div>
					<app-tag-configurator
						*ngIf="project.tags.size !== 0"
						displayMode="tags"
						configMode="View"
						[configuredTags]="project.tags"></app-tag-configurator>
				</div>
				<div *ngIf="project.isExpired" class="project-card__warning">
					<mat-icon [svgIcon]="DcIcons.WarningMessage"></mat-icon>
					<h2 i18n="@@project.list.expired.project">project expired</h2>
				</div>
				<div *ngIf="!project.isActive" class="project-card__warning">
					<mat-icon [svgIcon]="DcIcons.WarningMessage"></mat-icon>
					<h2 i18n="@@project.list.inactive.project">inactive project</h2>
				</div>
			</mat-card-content>
			<mat-card-footer class="project-card__footer">
				<div class="project-card__overlays-badges">
					<div class="project-card__overlays">
						<app-overlay-badge
							id="{{ cmpId }}-{{ index }}-admins-info-btn"
							[active]="true"
							[value]="project.adminCount"
							[icon]="ComponentIcons.Admin"
							[isOpen]="vo.openedOverlays.adminsPanelId === project.id"
							(click)="openAdminsOverlay($event, project.id)"
							(overlayDismiss)="closeOverlay()">
							<app-popover
								id="admins-popover"
								overlayContent
								[icon]="{ iconName: ComponentIcons.Admin }"
								label="admins"
								i18n-label="@@project.card.admins"
								(adbPopoverClose)="closeOverlay()">
								<mat-spinner
									*ngIf="vo.isLoadingMembers"
									[diameter]="20"></mat-spinner>
								<ng-container *ngIf="!vo.isLoadingMembers">
									<div class="members-popover"></div>
									<div
										*ngFor="let member of project.members"
										class="members-popover__row">
										<ng-container *ngIf="member.isAdmin">
											<div class="members-popover__avatar-name">
												<app-avatar [avatar]="member.avatar"></app-avatar>
												{{ member.name }}
											</div>
											<button
												id="{{ cmpId }}-{{ member.id }}-send-email-btn"
												mat-icon-button
												(click)="
													openSendEmailToAdminPopup(project.id, member.id)
												">
												<mat-icon [svgIcon]="DcIcons.Email"></mat-icon>
											</button>
										</ng-container>
									</div>
								</ng-container>
							</app-popover>
						</app-overlay-badge>
						<app-overlay-badge
							id="{{ cmpId }}-{{ index }}-members-info-btn"
							[active]="true"
							[value]="project.memberCount"
							[isOpen]="vo.openedOverlays.membersPanelId === project.id"
							(click)="openMembersOverlay($event, project.id)"
							[icon]="ComponentIcons.Member"
							(overlayDismiss)="closeOverlay()">
							<app-popover
								id="members-popover"
								overlayContent
								[icon]="{ iconName: ComponentIcons.Member }"
								label="members"
								i18n-label="@@project.card.members"
								(adbPopoverClose)="closeOverlay()">
								<mat-spinner
									*ngIf="vo.isLoadingMembers"
									[diameter]="20"></mat-spinner>
								<ng-container *ngIf="!vo.isLoadingMembers">
									<div class="members-popover">
										<div
											*ngFor="let member of project.members"
											class="members-popover__row">
											<div
												*ngIf="!member.isAdmin"
												class="members-popover__avatar-name">
												<app-avatar [avatar]="member.avatar"></app-avatar>
												{{ member.name }}
											</div>
										</div>
									</div>
								</ng-container>
							</app-popover>
						</app-overlay-badge>
						<app-overlay-badge
							*ngIf="project.isAdmin"
							id="{{ cmpId }}-{{ index }}-show-info-btn"
							[active]="true"
							[icon]="ComponentIcons.FolderInfo"
							[isOpen]="vo.openedOverlays.detailsPanelId === project.id"
							(overlayDismiss)="closeOverlay()"
							(click)="openInfoOverlay($event, project.id)">
							<app-popover
								class="info-popover"
								id="project-details-popover"
								overlayContent
								[icon]="{ iconName: ComponentIcons.FolderInfo }"
								label="info"
								i18n-label="@@project.card.information"
								(adbPopoverClose)="closeOverlay()">
								<ng-container
									[ngTemplateOutlet]="projectInfo"
									[ngTemplateOutletContext]="{
										$implicit: project
									}"></ng-container>
							</app-popover>
						</app-overlay-badge>
					</div>
					<div class="project-card__badges">
						<app-dc-core-badge [icon]="DcIcons.Version" [filled]="true">
							<span>
								{{ project.version }}
							</span>
						</app-dc-core-badge>
						<app-dc-core-badge
							[icon]="DcIcons.Date"
							[filled]="true"
							[type]="project.isExpired ? 'warning' : 'info'">
							<span>
								{{ project.expirationDate | dayjsDate: 'DateTime' }}
							</span>
						</app-dc-core-badge>
					</div>
				</div>

				<div class="project-card__footer-actions">
					<span *ngIf="project.accessedBy" class="project-card__last-access">
						<span i18n="@@project.card.lastAccess">last Access info</span>
						<app-dc-core-badge>
							<app-avatar
								*ngIf="project.accessedByAvatar"
								[avatar]="project.accessedByAvatar"
								[withTooltip]="true"></app-avatar>
							<span>
								{{ project.accessDate | dayjsDate: 'DateTime' }}
							</span>
						</app-dc-core-badge>
					</span>
					<div class="project-card__actions">
						<button
							id="{{ cmpId }}-{{ index }}-set-default-btn"
							class="project-card__actions-btn"
							mat-icon-button
							color="primary"
							(click)="setDefault($event, project)"
							[disabled]="project.isExpired || !project.isActive">
							<mat-icon
								[svgIcon]="
									project.isDefault ? DcIcons.KeepFilled : DcIcons.Keep
								"></mat-icon>
						</button>
						<button
							id="{{ cmpId }}-{{ index }}-set-favorite-btn"
							class="project-card__actions-btn"
							mat-icon-button
							color="primary"
							(click)="setFavorite($event, project)"
							[disabled]="project.isExpired || !project.isActive">
							<mat-icon
								[svgIcon]="
									project.isFavorite ? DcIcons.FavoriteFilled : DcIcons.Favorite
								"></mat-icon>
						</button>
					</div>
				</div>
			</mat-card-footer>
		</mat-card>
	</ng-template>
	<ng-template #projectInfo let-project>
		<div class="project-info-popover">
			<!-- code -->
			<div class="label">
				<span i18n="@@project.list.info.code">code</span>
			</div>
			<div class="value">
				<span>{{ project.code }}</span>
			</div>

			<!-- id -->
			<div class="label">
				<span i18n="@@project.list.info.id">ID</span>
			</div>
			<div class="value">
				<span>{{ project.id }}</span>
			</div>

			<!-- creation -->
			<div class="label">
				<span i18n="@@project.list.info.creation">creation</span>
			</div>
			<div class="label sub-label">
				<span i18n="@@project.list.info.user">user</span>
			</div>
			<div class="value">
				<span *ngIf="project.createdBy">
					<app-dc-user [dcUserUuid]="project.createdBy"></app-dc-user>
				</span>
			</div>
			<div class="label sub-label">
				<span i18n="@@project.list.info.date">date</span>
			</div>
			<div class="value">
				<span>
					{{ project.creationDate | date: 'yyyy-MM-dd HH:mm:ss' }}
				</span>
			</div>

			<!-- update -->
			<div class="label">
				<span i18n="@@project.list.info.update">update</span>
			</div>
			<div class="label sub-label">
				<span i18n="@@project.list.info.user">user</span>
			</div>
			<div class="value">
				<span *ngIf="project.updatedBy">
					<app-dc-user [dcUserUuid]="project.updatedBy"></app-dc-user>
				</span>
			</div>
			<div class="label sub-label">
				<span i18n="@@project.list.info.date">date</span>
			</div>
			<div class="value">
				<span>
					{{ project.updateDate | date: 'yyyy-MM-dd HH:mm:ss' }}
				</span>
			</div>
		</div>
	</ng-template>
</div>
